import { Component, EventEmitter, Input, Output} from '@angular/core';
@Component({
    selector: 'i18n-msg',
    templateUrl: './i18n-msg.component.html'
})
export class I18nMsgComponent {
    @Input() public key;
    @Input() public set type(t: string){
        if (t === '' || t === undefined) {
            this._type = 'text';
        }else {
            this._type = t;
        }
    }
    @Input() public remark;
    @Input() public param;

    private _type= 'text'; //기본은 text

    public get type(): string {
        return this._type;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/i18n-msg/i18n-msg.component.ts